"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.container = exports.inline = exports.horizontal = exports.vertical = void 0;

var react_1 = require("@emotion/react");

exports.vertical = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  word-break: keep-all;\n  width: 100%;\n"])));
exports.horizontal = react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  & > div {\n    margin-bottom: 8px;\n  }\n\n  & > div > div {\n    justify-content: flex-start;\n  }\n\n  & > div::last-of-type {\n    margin-bottom: 0px;\n  }\n"])));
exports.inline = react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-wrap: wrap;\n  margin-top: -8px;\n\n  & > div {\n    margin-top: 8px;\n  }\n"])));
var directionStyles = {
  vertical: exports.vertical,
  horizontal: exports.horizontal,
  inline: exports.inline
};

var container = function container(direction) {
  return react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n"])), directionStyles[direction]);
};

exports.container = container;